import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from '../../TextBlock'

import { TextBoxFontLgBold, TextBoxFontSmBold } from 'atoms/TextBox/Templates'
import { Colors } from 'atoms/TextBox/TextBox.h'
import { TextBlock } from '../../TextBlock'
import { TextBlockRowGap } from '../../TextBlock.h'

export interface ITextBlockTVShowsInfoProps extends Omit<
  ITextBlockProps,
  'children'
> {
  title: ITextBoxProps['title']
  description: ITextBoxProps['title']
}

export const TextBlockTVShowsInfo = ({
  title,
  description,
  rowGap = TextBlockRowGap.INDENT_0,
  ...rest
}: ITextBlockTVShowsInfoProps): JSX.Element => {
  return (
    <TextBlock rowGap={rowGap} {...rest}>
      <TextBoxFontSmBold
        maxLines={1}
        title={title}
        color={Colors.TEXT_ICON_SECONDARY}
      />
      <TextBoxFontLgBold title={description} />
    </TextBlock>
  )
}
